(function() {
  'use strict';

  var pdp = document.querySelector('.luxury-pdp');
  if (!pdp) return;

  var sectionId = pdp.dataset.sectionId;
  var currentHandle = pdp.dataset.productHandle;
  var isEl = (document.documentElement.lang || '').toLowerCase().indexOf('el') === 0;

  // Mirror server: shop.money_format is `€{{amount_no_decimals}}` (cents always dropped).
  // money_without_trailing_zeros + that format = €X with EU period thousands separator.
  // Bug: previously routed through Shopify.formatMoney which inconsistently honored the
  // no-decimals token on this storefront — clicking a variant could output €652,00.
  // Fix: deterministic local formatter, no dependency on Shopify globals.
  function formatMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    // Math.round to match Shopify's {{amount_no_decimals}} server output
    // (e.g., 10760 cents → €108, not €107).
    var whole = Math.round(cents / 100);
    return '€' + String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[<>"&]/g, function(c) {
      return { '<':'&lt;','>':'&gt;','"':'&quot;','&':'&amp;' }[c];
    });
  }

  // 2026-07-09 perf: size a Shopify CDN image URL to width w. Shopify URLs
  // always carry '?v=', so the old "indexOf('?')" guard served the NATIVE
  // full-res file (~677KB) into a ~308px thumb. Append width with the correct
  // separator ('&' when a query already exists) so the CDN actually resizes.
  function ctlSized(u, w) {
    if (typeof u !== 'string' || !u) return u;
    u = u.replace(/([?&])width=\d+/g, '$1').replace(/[?&]$/, '');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  // R6.5α Bug 1.2 — reject empty rec entries before render
  function isRenderable(p) {
    if (!p) return false;
    if (!p.title) return false;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (!img) return false;
    return true;
  }

  // ─── Image gallery ────────────────
  var thumbs = pdp.querySelectorAll('.lux-thumb');
  var mainImgs = pdp.querySelectorAll('.lux-main-img');

  function setActiveByMediaId(mediaId) {
    thumbs.forEach(function(t) {
      var on = t.dataset.mediaId === mediaId;
      t.classList.toggle('active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    mainImgs.forEach(function(img) {
      img.classList.toggle('active', img.dataset.mediaId === mediaId);
    });
  }

  function activeIndex() {
    for (var i = 0; i < mainImgs.length; i++) {
      if (mainImgs[i].classList.contains('active')) return i;
    }
    return 0;
  }

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      setActiveByMediaId(thumb.dataset.mediaId);
    });
  });

  // Prev/next arrow navigation
  var prevBtn = pdp.querySelector('[data-gallery-prev]');
  var nextBtn = pdp.querySelector('[data-gallery-next]');
  function step(delta) {
    if (mainImgs.length < 2) return;
    var idx = activeIndex();
    var next = (idx + delta + mainImgs.length) % mainImgs.length;
    var nextId = mainImgs[next] && mainImgs[next].dataset.mediaId;
    if (nextId) setActiveByMediaId(nextId);
  }
  if (prevBtn) prevBtn.addEventListener('click', function(e) { e.preventDefault(); step(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function(e) { e.preventDefault(); step(1); });

  // ─── Variant selector ─────────────────
  var sizeBtns = pdp.querySelectorAll('.lux-size');
  var variantInput = pdp.querySelector('[data-variant-id-input]');
  var shopPayVariantInput = pdp.querySelector('[data-shop-pay-variant-id]');
  var priceEl = pdp.querySelector('[data-price]');
  var priceOldEl = pdp.querySelector('[data-price-old]');
  var stockBadge = pdp.querySelector('[data-stock-badge]');
  var stockText = pdp.querySelector('[data-stock-text]');
  var atbBtn = pdp.querySelector('[data-atb]');
  var atbText = pdp.querySelector('[data-atb-text]');
  var atbAddText = atbBtn && atbBtn.dataset.textAdd;
  var atbSoldText = atbBtn && atbBtn.dataset.textSoldout;

  function updateStockText(available, inv) {
    if (!stockText) return;
    if (!available || inv === 0) {
      stockText.textContent = stockText.dataset.textOos || '';
      stockText.classList.add('lux-stock-text--oos');
      stockText.classList.remove('lux-stock-text--limited');
      stockText.removeAttribute('hidden');
    } else if (inv > 0 && inv <= 3) {
      // #3a real scarcity: prefer exact-count copy ("Only N left") when the
      // template is present; fall back to the generic limited line otherwise.
      var remaining = stockText.dataset.textRemaining;
      stockText.textContent = (remaining && inv > 1) ? remaining.replace('__N__', inv) : (stockText.dataset.textLimited || '');
      stockText.classList.add('lux-stock-text--limited');
      stockText.classList.remove('lux-stock-text--oos');
      stockText.removeAttribute('hidden');
    } else {
      stockText.textContent = '';
      stockText.classList.remove('lux-stock-text--oos', 'lux-stock-text--limited');
      stockText.setAttribute('hidden', '');
    }
  }

  function selectVariantButton(btn) {
    if (!btn) return;
    var available = btn.dataset.variantAvailable === 'true';
    sizeBtns.forEach(function(b) {
      var on = b === btn;
      b.classList.toggle('active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });

    var variantId = btn.dataset.variantId;
    var price = parseInt(btn.dataset.variantPrice, 10);
    var compare = parseInt(btn.dataset.variantCompare, 10);
    var inv = parseInt(btn.dataset.variantInv, 10);

    if (variantInput && variantId) variantInput.value = variantId;
    if (shopPayVariantInput && variantId) shopPayVariantInput.value = variantId;

    if (priceEl && !isNaN(price)) priceEl.textContent = formatMoney(price);
    if (priceOldEl) {
      if (!isNaN(compare) && compare > price) {
        priceOldEl.textContent = formatMoney(compare);
        priceOldEl.removeAttribute('hidden');
      } else { priceOldEl.setAttribute('hidden', ''); }
    }

    updateStockText(available, isNaN(inv) ? 0 : inv);

    if (stockBadge) {
      if (available) stockBadge.removeAttribute('hidden');
      else stockBadge.setAttribute('hidden', '');
    }

    if (atbBtn) {
      atbBtn.disabled = !available;
      if (atbText) atbText.textContent = available ? (atbAddText || atbText.textContent) : (atbSoldText || 'SOLD OUT');
    }

    if (variantId && history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    try {
      pdp.dispatchEvent(new CustomEvent('lux:variant-change', { bubbles: true, detail: { variantId: variantId, price: price, available: available } }));
    } catch (e) {}
  }

  sizeBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) { e.preventDefault(); selectVariantButton(btn); });
    btn.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectVariantButton(btn); }
    });
  });

  // ─── Card render (used by JS-rendered Recently Viewed + JS recs fallback) ───
  function renderCard(p) {
    if (!isRenderable(p)) return '';
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var thumbUrl = '';
    if (img) {
      if (typeof img === 'string') thumbUrl = img;
      else if (img.src) thumbUrl = img.src;
    }
    var price = typeof p.price === 'number' ? p.price : (p.price ? parseInt(p.price, 10) : 0);
    var compare = typeof p.compare_at_price === 'number' ? p.compare_at_price : (p.compare_at_price ? parseInt(p.compare_at_price, 10) : 0);
    var displayTitle = p.title || '';
    if (isEl && p.title_el) displayTitle = p.title_el;
    var titleEsc = escHtml(displayTitle);
    var vendorEsc = escHtml(p.vendor);
    var url = p.url || ('/products/' + (p.handle || ''));
    var compareHtml = (compare && compare > price) ? '<span class="lux-card-price-compare">' + formatMoney(compare) + '</span>' : '';
    return [
      '<a href="' + url + '" class="lux-ctl-card" aria-label="' + titleEsc + '">',
        '<div class="lux-ctl-card-img">',
          thumbUrl ? ('<img src="' + ctlSized(thumbUrl, 600) + '" srcset="' + ctlSized(thumbUrl, 300) + ' 300w, ' + ctlSized(thumbUrl, 400) + ' 400w, ' + ctlSized(thumbUrl, 600) + ' 600w, ' + ctlSized(thumbUrl, 800) + ' 800w" sizes="(min-width: 750px) 320px, 45vw" alt="' + titleEsc + '" loading="lazy" decoding="async" width="400" height="500">') : '',
        '</div>',
        '<div class="lux-ctl-card-vendor">' + vendorEsc.toUpperCase() + '</div>',
        '<div class="lux-ctl-card-title">' + titleEsc + '</div>',
        '<div class="lux-card-price">',
          '<span class="lux-card-price-current">' + formatMoney(price) + '</span>',
          compareHtml,
        '</div>',
      '</a>'
    ].join('');
  }

  // ─── Recommendations (JS fallback if server-side empty) ──────────────
  var ctl = pdp.querySelector('.lux-ctl[data-recommendations-url]');
  if (ctl) {
    var ctlGrid = ctl.querySelector('[data-ctl-grid]');
    var recUrl = ctl.dataset.recommendationsUrl;
    if (ctlGrid && recUrl) {
      fetch(recUrl, { credentials: 'same-origin' })
        .then(function(r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function(data) {
          if (data && Array.isArray(data.products)) {
            var renderable = data.products.filter(isRenderable).slice(0, 4);
            if (renderable.length > 0) {
              ctlGrid.innerHTML = renderable.map(renderCard).join('');
              ctl.removeAttribute('hidden');
            } else {
              ctl.setAttribute('hidden', '');
            }
          }
        })
        .catch(function() {});
    }
  }

  // ─── Recently Viewed (D2 from Round 3) ──────────────
  var RV_KEY = 'mensedit_recent_views';
  var RV_CAP = 8;
  function rvGet() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; }
  }
  function rvSave(arr) {
    try { localStorage.setItem(RV_KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function rvTrack() {
    var blob = document.getElementById('lux-current-product');
    if (!blob) return;
    var data;
    try { data = JSON.parse(blob.textContent); } catch (e) { return; }
    if (!data || !data.handle) return;
    var arr = rvGet();
    arr = arr.filter(function(p) { return p.handle !== data.handle; });
    arr.unshift({
      handle: data.handle,
      title: data.title || '',
      title_el: data.title_el || '',
      vendor: data.vendor || '',
      url: data.url || '/products/' + data.handle,
      price: typeof data.price === 'number' ? data.price : 0,
      compare_at_price: typeof data.compare_at_price === 'number' ? data.compare_at_price : 0,
      featured_image: data.featured_image || ''
    });
    if (arr.length > RV_CAP) arr = arr.slice(0, RV_CAP);
    rvSave(arr);
  }
  function rvRender() {
    var sec = document.querySelector('.lux-recently');
    if (!sec) return;
    var grid = sec.querySelector('[data-recently-grid]');
    if (!grid) return;
    var arr = rvGet();
    var items = arr.filter(function(p) { return p.handle !== currentHandle; }).filter(isRenderable).slice(0, 4);
    if (items.length === 0) { sec.setAttribute('hidden', ''); return; }
    grid.innerHTML = items.map(renderCard).join('');
    sec.removeAttribute('hidden');
  }
  rvRender();
  rvTrack();

  // ─── Modal handlers (size guide) ──────────────
  var modalTriggers = pdp.querySelectorAll('[data-modal-trigger]');
  modalTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      var modal = document.getElementById(trigger.dataset.modalTrigger);
      if (modal && typeof modal.showModal === 'function') modal.showModal();
      else if (modal) modal.setAttribute('open', '');
    });
  });
  var modals = pdp.querySelectorAll('[data-modal]');
  modals.forEach(function(modal) {
    var closeBtn = modal.querySelector('[data-modal-close]');
    if (closeBtn) closeBtn.addEventListener('click', function() {
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
    });
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      }
    });
    var langBtns = modal.querySelectorAll('[data-lang]');
    var langContents = modal.querySelectorAll('[data-lang-content]');
    langBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var lang = btn.dataset.lang;
        langBtns.forEach(function(b) { b.classList.toggle('active', b === btn); });
        langContents.forEach(function(c) {
          if (c.dataset.langContent === lang) c.removeAttribute('hidden');
          else c.setAttribute('hidden', '');
        });
      });
    });
  });

  // ─── Sticky ATB on mobile ────────────────
  if (atbBtn && window.matchMedia('(max-width: 767px)').matches && 'IntersectionObserver' in window) {
    var sentinel = document.createElement('div');
    sentinel.className = 'lux-atb-sentinel';
    atbBtn.parentNode.insertBefore(sentinel, atbBtn);
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        atbBtn.classList.toggle('lux-atb--stuck', !e.isIntersecting);
      });
    }, { rootMargin: '0px 0px -100% 0px', threshold: 0 });
    io.observe(sentinel);
  }
})();
